// import { createGlobalStore } from "use-global-state-react";

// export default createGlobalStore("encryptkey", ["hkgf76tyulk"]);
export const SECRETPW = "ambtiptopxyz";
